exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".css-15k3avv{\r\n    margin:0 !important;\r\n\r\n}\r\n\r\n.css-uxwzoy,.css-1wwvboz{\r\n    z-index: 1000001 !important;\r\n}", ""]);

// exports
